export const commonColor = {
  WARN: '#FF9900', // 노란색
  FAIL: '#E02020', // 빨간색
  WHITE: '#FFFFFF', // 흰색
  NORMAL: '#19BE6B', // 초록색
  BLUE: '#2B85E4', // 파란색
  PINK: '#F7C0BA', // 분홍색
}
